import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vector",
  "use": "icon-vector-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"icon-vector\"><path d=\"M7.743 11.132 17.875 1M17.875 1l-5.987 16.58a.507.507 0 0 1-.921 0l-3.224-6.448-6.447-3.224a.507.507 0 0 1 0-.921L17.875 1Z\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol